import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateCategoryVenues } from 'src/api/updateCategoryVenues/updateCategoryVenues';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { QueryKeys } from '../QueryKeys';

type TUpdateCategoryVenues = {
  categoryId: string;
  venueIds: string[];
};

export const useUpdateCategoryVenues = () => {
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();

  return useMutation(
    async ({ categoryId, venueIds }: TUpdateCategoryVenues) =>
      updateCategoryVenues(categoryId, {
        venue_ids: venueIds,
      }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: [getBrandId(), QueryKeys.venues] });
        await queryClient.invalidateQueries({ queryKey: [getBrandId(), QueryKeys.venueCategories] });
        showSnackbar({
          message: 'You have successfully updated venue categories',
          status: SnackbarStatus.SUCCESS,
        });
      },
      onError: () => {
        showSnackbar({
          message: 'Something went wrong whilst updating venue categories.',
          status: SnackbarStatus.ERROR,
        });
      },
    },
  );
};
